<template>
    <VueDatePicker
        v-model="internalValue"
        :range="isRange"
        :inline="true"
        :enable-time-picker="false"
        :allowed-dates="enabledDates && enabledDates.length ? enabledDates : undefined"
        :month-change-on-scroll="false"
        :multi-calendars="monthsToShow > 1 ? { count: monthsToShow } : false"
        :min-date="minDate || undefined"
        :start-date="calendarStart"
        locale="nl"
        auto-apply
        @update:model-value="onUpdate"
    />
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';

export default {
    name: 'AirbnbStyleDatepicker',
    components: { VueDatePicker },
    props: {
        mode: { type: String, default: 'range' },
        dateOne: { type: [String, Date, Number], default: null },
        dateTwo: { type: [String, Date, Number], default: null },
        enabledDates: { type: Array, default: () => [] },
        monthsToShow: { type: Number, default: 2 },
        minDate: { type: [String, Date], default: null },
        startValue: { type: Array, default: null },
    },
    emits: ['date-one-selected', 'date-two-selected'],
    data() {
        return {
            internalValue: null,
        };
    },
    computed: {
        isRange() {
            return this.mode !== 'single';
        },
        calendarStart() {
            if (this.isRange && Array.isArray(this.internalValue) && this.internalValue[0]) {
                return this.internalValue[0];
            }
            if (!this.isRange && this.internalValue) {
                return this.internalValue;
            }
            return new Date();
        },
    },
    watch: {
        dateOne: { immediate: true, handler: 'syncValue' },
        dateTwo: { handler: 'syncValue' },
        startValue: { handler: 'syncValue' },
    },
    methods: {
        parseDate(value) {
            if (value == null || value === '') return null;

            let date;
            if (value instanceof Date) {
                date = value;
            } else if (typeof value === 'number') {
                date = new Date(value < 1e12 ? value * 1000 : value);
            } else if (typeof value === 'string') {
                if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
                    date = new Date(`${value.slice(0, 10)}T00:00:00`);
                } else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
                    const [first, second, year] = value.split('/').map(Number);
                    date = first > 12
                        ? new Date(year, second - 1, first)
                        : new Date(year, first - 1, second);
                } else {
                    date = new Date(value);
                }
            } else {
                date = new Date(value);
            }

            if (!(date instanceof Date) || isNaN(date.getTime()) || date.getFullYear() <= 1970) {
                return null;
            }
            return date;
        },
        syncValue() {
            const start = Array.isArray(this.startValue) ? this.startValue : [];
            const one = this.parseDate(this.dateOne) || this.parseDate(start[0]);
            const two = this.parseDate(this.dateTwo) || this.parseDate(start[1]);

            if (this.isRange) {
                this.internalValue = one ? [one, two] : null;
            } else {
                this.internalValue = one;
            }
        },
        onUpdate(val) {
            if (this.isRange && Array.isArray(val)) {
                this.$emit('date-one-selected', val[0] ? this.toDateString(val[0]) : null);
                this.$emit('date-two-selected', val[1] ? this.toDateString(val[1]) : null);
            } else if (val) {
                this.$emit('date-one-selected', this.toDateString(val));
            }
        },
        toDateString(date) {
            const parsed = this.parseDate(date);
            if (!parsed) return null;
            const y = parsed.getFullYear();
            const m = String(parsed.getMonth() + 1).padStart(2, '0');
            const day = String(parsed.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
    },
};
</script>
